import { NavLink } from "react-router-dom";
import { Home, Mic, MessageSquare, Building2 } from "lucide-react";
import { cn } from "../lib/utils";

/** All users see 4 tabs: Home, Chat, Record, Accounts */
const NAV_ITEMS = [
  { to: "/copilot/home", label: "Home", icon: Home },
  { to: "/copilot/chat", label: "Chat", icon: MessageSquare },
  { to: "/copilot/record", label: "Record", icon: Mic },
  { to: "/copilot/account", label: "Accounts", icon: Building2 },
] as const;

export function BottomNav() {
  const items = NAV_ITEMS;

  return (
    <nav
      className="copilot-bottom-nav fixed inset-x-0 bottom-0 z-50 border-t border-border bg-surface"
    >
      <div className="flex h-nav items-stretch">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                "flex flex-1 flex-col items-center justify-center gap-0.5",
                "min-h-touch text-xs font-medium transition-colors",
                isActive
                  ? "text-brand"
                  : "text-text-muted active:text-text-secondary"
              )
            }
          >
            <Icon className="h-5 w-5" strokeWidth={2} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
